import { withInstall } from '@xzx-design/utils'
import _Search from './src/search'

export const Search = withInstall(_Search)
export default Search

export * from './src/search'
